<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="型号名称" prop="name">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.name"
                placeholder="型号名称"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备类型" prop="deviceTypeId">
              <el-select
                 :disabled="model==='view'" v-model="form.deviceTypeId"
                style="width: 100%"
                placeholder="设备类型"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in deviceTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="厂商" prop="manufacturer">
              
              <el-select
                 :disabled="model==='view'" v-model="form.manufacturer"
                style="width: 100%"
                placeholder="设备类型"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in partnerList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="购买价格" prop="price">
              <money-input
                 :disabled="model==='view'" v-model="form.price"
                templateName="元"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="设备大类" prop="deviceCategory"> 
              
              <el-select
                 :disabled="model==='view'" v-model="form.deviceCategory"
                style="width: 100%"
                placeholder="设备大类"
              >
                <el-option
                  v-for="item in deviceCategoryList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="编码" prop="code">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.code"
                placeholder="编码"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                clearable
                 :disabled="model==='view'" v-model="form.remark"
                placeholder="备注"
                maxlength="300"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
  <script>
import { saveDeviceModel } from '../api/serveItemManage';
import {
  getDeviceModelPage,
  getDeviceTypeList,
  getNursinghome,
  getPartnerList,
  updateDeviceModel
} from '../api/serveItemManage';
import { getDictionary } from '@/api/common.js';

export default {
  components: {},

  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],

      form: {
        name: '',
        sex: '',
        tel: '',
        adress: '',
        relationship: '',
        isWatch: '',
        code: '',
      },
      formRules: {
        name: [{ required: true, message: '型号名称不能为空', trigger: 'blur' }],
        //   projectId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
      },
      matetialList: [],
      deviceTypeList:[],
      partnerList: [],
      deviceCategoryList:[],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    getGenderByIdNumber(idNumber) {
      if (idNumber) {
        let genderCode; // 性别代码
        if (idNumber.length == 18) {
          // 二代身份证号码长度为18位（第17位为性别代码）
          genderCode = idNumber.charAt(16);
        } else if (idNumber.length == 15) {
          // 一代身份证号码长度为15位（第15位为性别代码）
          genderCode = idNumber.charAt(14);
        }
        if (genderCode && !isNaN(genderCode)) {
          // 两代身份证号码的性别代码都为男奇女偶
          if (parseInt(genderCode) % 2 == 0) {
            return 'female';
          }
          return 'male';
        }
      }
    },

    async initData() {
      // getProjectList().then((res) => {
      //   this.projectList = res.data;
      // });
      if(this.model === 'add'){
      }else{
        this.form = this._.cloneDeep(this.row);;
      }
      
      getDictionary('nursinghome_device_category').then((res) => {
        this.deviceCategoryList = res.data;
      });
      getDeviceTypeList({id: this.nursinghomeId}).then((res) => {
        this.deviceTypeList = res.data;
      });
          getPartnerList({id: this.nursinghomeId}).then((res)=>{
            this.partnerList = res.data;
          });
      if (this.model == 'add') {
      } else {
      }
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          if (this.model == 'add') {
              saveDeviceModel({nursinghomeId:this.nursinghomeId, ...this.form}).then(res=>{
                this.$emit('success', this.form);
              })
          } else {
              updateDeviceModel({nursinghomeId:this.nursinghomeId, ...this.form}).then(res=>{
                this.$emit('success', this.form);
              })
          }
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
  